// Generated from the validated Extreme scene plan. The stage and the page read this script.
export const SCENE_OBJECTS = [
  {
    "id": "brute_key",
    "component": "BruteKeyModel",
    "label": "Brute candy key",
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "size": 1.6,
    "dims": [
      1.6,
      0.55,
      0.22
    ],
    "behavior": "The key turns in its barrel as the page scrolls, the bit teeth click past the pin stack one by one, and the collar ring flips magenta-to-tangerine on hover states.",
    "parts": [
      {
        "id": "bow",
        "label": "Bow",
        "description": "Rounded candy-pink head with ink outline and a sticker-dot hole.",
        "shell": true,
        "position": [
          -0.55,
          0,
          0
        ],
        "size": 0.5,
        "explode": [
          -0.35,
          0.05,
          0.0
        ],
        "move": "lift",
        "children": [
          {
            "id": "bow_ring",
            "label": "Sticker-dot ring",
            "count": 1,
            "explode": [
              -0.12,
              0.06,
              0.0
            ]
          },
          {
            "id": "bow_face",
            "label": "Bow face plate",
            "count": 1,
            "explode": [
              -0.06,
              0.12,
              0.0
            ]
          }
        ]
      },
      {
        "id": "shaft",
        "label": "Shaft",
        "description": "Straight candy-pink bar with ink outline running from bow to bit.",
        "shell": false,
        "position": [
          0,
          0,
          0
        ],
        "size": 0.9,
        "explode": [
          0.0,
          0.18,
          0.0
        ],
        "move": "slide",
        "children": [
          {
            "id": "shaft_core",
            "label": "Core rod",
            "count": 1,
            "explode": [
              0.0,
              0.1,
              0.0
            ]
          },
          {
            "id": "shaft_sleeve",
            "label": "Sleeve",
            "count": 1,
            "explode": [
              0.0,
              -0.1,
              0.0
            ]
          }
        ]
      },
      {
        "id": "bit",
        "label": "Bit",
        "description": "Toothed candy-pink block at the tip with ink outline.",
        "shell": false,
        "position": [
          0.55,
          -0.05,
          0
        ],
        "size": 0.45,
        "explode": [
          0.35,
          -0.05,
          0.0
        ],
        "move": "slide",
        "children": [
          {
            "id": "teeth",
            "label": "Teeth",
            "count": 5,
            "explode": [
              0.08,
              -0.06,
              0.0
            ]
          },
          {
            "id": "bit_body",
            "label": "Bit body",
            "count": 1,
            "explode": [
              0.05,
              0.05,
              0.0
            ]
          }
        ]
      },
      {
        "id": "collar",
        "label": "Collar ring",
        "description": "Tangerine ring around the shaft near the bow.",
        "shell": false,
        "position": [
          -0.2,
          0,
          0
        ],
        "size": 0.28,
        "explode": [
          -0.1,
          0.22,
          0.0
        ],
        "move": "spin",
        "children": [
          {
            "id": "collar_segments",
            "label": "Ring segments",
            "count": 4,
            "explode": [
              0.0,
              0.08,
              0.0
            ]
          }
        ]
      },
      {
        "id": "pin_stack",
        "label": "Pin stack",
        "description": "Lime status pins inside the bit that the teeth click past.",
        "shell": false,
        "position": [
          0.55,
          -0.05,
          0.06
        ],
        "size": 0.3,
        "explode": [
          0.2,
          -0.2,
          0.12
        ],
        "move": "lift",
        "children": [
          {
            "id": "pins",
            "label": "Pins",
            "count": 5,
            "explode": [
              0.04,
              -0.05,
              0.03
            ]
          }
        ]
      },
      {
        "id": "barrel",
        "label": "Barrel",
        "description": "Ink-outlined housing the shaft turns inside.",
        "shell": true,
        "position": [
          0.05,
          0,
          0
        ],
        "size": 0.7,
        "explode": [
          0.0,
          -0.3,
          0.0
        ],
        "move": "hinge",
        "children": [
          {
            "id": "barrel_shell",
            "label": "Barrel shell",
            "count": 1,
            "explode": [
              0.0,
              -0.12,
              0.0
            ]
          },
          {
            "id": "barrel_bearing",
            "label": "Bearing",
            "count": 1,
            "explode": [
              0.0,
              -0.06,
              0.0
            ]
          }
        ]
      }
    ]
  }
];

export const SHOTS = [
  {
    "id": "poster_open",
    "section": "LandingPosterStage",
    "depth": 0,
    "focus": null,
    "camera": [
      0.0,
      0.2,
      2.6
    ],
    "target": [
      0.0,
      0.0,
      0.0
    ],
    "fov": 35.0,
    "explode": 0.0,
    "cutaway": 0.0,
    "explode_part": 0.0,
    "action": 0.2,
    "anchor": "brute_key",
    "card": "left",
    "composition": "split",
    "layout": {
      "cardWidth": 0.38,
      "fill": 0.5
    },
    "eyebrow": "Authorized targets only",
    "staging": "behind_type",
    "callout": {
      "title": "Find the weak password before someone else does",
      "fact": "Brute is a Windows desktop password-testing tool.",
      "value": "Start an authorized test and see the weak spots first."
    },
    "labels": [],
    "card_style": "stamp",
    "side": 1
  },
  {
    "id": "key_profile",
    "section": "LandingKeyChapter",
    "depth": 1,
    "focus": "brute_key.bow",
    "camera": [
      -1.4,
      0.1,
      1.6
    ],
    "target": [
      -0.55,
      0.0,
      0.0
    ],
    "fov": 35.0,
    "explode": 0.1,
    "cutaway": 0.0,
    "explode_part": 0.0,
    "action": 0.6,
    "anchor": "brute_key.bow",
    "card": "right",
    "composition": "split",
    "layout": {
      "cardWidth": 0.26,
      "fill": 0.72
    },
    "eyebrow": "Bow \u00b7 candy pink",
    "staging": "profile",
    "callout": {
      "title": "The head you hold",
      "fact": "The bow carries the sticker-dot ring and the ink outline.",
      "value": "A tool you recognize at a glance."
    },
    "labels": [],
    "card_style": null,
    "side": -1
  },
  {
    "id": "key_xray",
    "section": "LandingKeyChapter",
    "depth": 1,
    "focus": "brute_key.barrel",
    "camera": [
      0.4,
      0.3,
      1.9
    ],
    "target": [
      0.05,
      0.0,
      0.0
    ],
    "fov": 35.0,
    "explode": 0.12,
    "cutaway": 0.0,
    "explode_part": 0.0,
    "action": 0.8,
    "anchor": "brute_key.barrel",
    "card": "left",
    "composition": "annotate",
    "layout": {
      "cardWidth": 0.2,
      "fill": 0.85
    },
    "eyebrow": "Barrel \u00b7 inside",
    "staging": "x_ray",
    "callout": {
      "title": "The shaft turns in its barrel",
      "fact": "The barrel is the housing the shaft turns inside.",
      "value": "Every run is a controlled turn, not a guess."
    },
    "labels": [],
    "card_style": "inverse",
    "side": 1
  },
  {
    "id": "engine_explode",
    "section": "LandingEngineChapter",
    "depth": 2,
    "focus": "brute_key",
    "camera": [
      0.2,
      0.6,
      3.4
    ],
    "target": [
      0.0,
      0.0,
      0.0
    ],
    "fov": 35.0,
    "explode": 1.0,
    "cutaway": 0.0,
    "explode_part": 0.0,
    "action": 0.4,
    "anchor": "brute_key.bit",
    "card": "right",
    "composition": "labels",
    "layout": {
      "cardWidth": 0.24,
      "fill": 0.78
    },
    "eyebrow": "Bit \u00b7 five teeth",
    "staging": "standard",
    "labels": [
      {
        "anchor": "brute_key.bow",
        "text": "Bow \u00b7 candy pink"
      },
      {
        "anchor": "brute_key.shaft",
        "text": "Shaft \u00b7 core + sleeve"
      },
      {
        "anchor": "brute_key.bit",
        "text": "Bit \u00b7 5 teeth"
      },
      {
        "anchor": "brute_key.collar",
        "text": "Collar \u00b7 tangerine ring"
      }
    ],
    "callout": {
      "title": "Every part comes apart",
      "fact": "The key separates into bow, shaft, bit, collar, pin stack and barrel.",
      "value": "You can see exactly what the test touches."
    },
    "card_style": null,
    "side": -1
  },
  {
    "id": "engine_teeth",
    "section": "LandingEngineChapter",
    "depth": 3,
    "focus": "brute_key.bit",
    "camera": [
      1.1,
      -0.2,
      0.9
    ],
    "target": [
      0.55,
      -0.05,
      0.0
    ],
    "fov": 35.0,
    "explode": 0.15,
    "cutaway": 0.0,
    "explode_part": 1.0,
    "action": 0.9,
    "anchor": "brute_key.bit.teeth",
    "card": "left",
    "composition": "annotate",
    "layout": {
      "cardWidth": 0.22,
      "fill": 0.82
    },
    "eyebrow": "Teeth \u00b7 one by one",
    "staging": "standard",
    "callout": {
      "title": "Five teeth, five clicks",
      "fact": "The bit carries five teeth that click past the pin stack.",
      "value": "Progress you can count, not a spinner."
    },
    "labels": [],
    "card_style": "tag",
    "side": 1
  },
  {
    "id": "log_pins",
    "section": "LandingLogChapter",
    "depth": 3,
    "focus": "brute_key.pin_stack",
    "camera": [
      0.9,
      -0.4,
      0.8
    ],
    "target": [
      0.55,
      -0.05,
      0.06
    ],
    "fov": 35.0,
    "explode": 0.15,
    "cutaway": 0.0,
    "explode_part": 0.9,
    "action": 1.0,
    "anchor": "brute_key.pin_stack.pins",
    "card": "right",
    "composition": "split",
    "layout": {
      "cardWidth": 0.24,
      "fill": 0.8
    },
    "eyebrow": "Pins \u00b7 lime",
    "staging": "standard",
    "callout": {
      "title": "Five pins, one live line",
      "fact": "The pin stack holds five lime status pins.",
      "value": "Each pin is a log line you can read."
    },
    "labels": [],
    "card_style": "glass",
    "side": -1
  },
  {
    "id": "report_collar",
    "section": "LandingReportChapter",
    "depth": 1,
    "focus": "brute_key.collar",
    "camera": [
      -0.6,
      0.4,
      1.7
    ],
    "target": [
      -0.2,
      0.0,
      0.0
    ],
    "fov": 35.0,
    "explode": 0.1,
    "cutaway": 0.0,
    "explode_part": 0.0,
    "action": 0.7,
    "anchor": "brute_key.collar",
    "card": "left",
    "composition": "pane",
    "layout": {
      "cardWidth": 0.3,
      "fill": 0.65
    },
    "eyebrow": "Collar \u00b7 tangerine",
    "staging": "standard",
    "callout": {
      "title": "The ring that marks the run",
      "fact": "The tangerine collar ring sits on the shaft near the bow.",
      "value": "Findings and reports carry the same mark."
    },
    "labels": [],
    "card_style": "stamp",
    "side": 1
  },
  {
    "id": "close_whole",
    "section": "LandingCloseChapter",
    "depth": 0,
    "focus": null,
    "camera": [
      0.0,
      0.3,
      2.8
    ],
    "target": [
      0.0,
      0.0,
      0.0
    ],
    "fov": 35.0,
    "explode": 0.0,
    "cutaway": 0.0,
    "explode_part": 0.0,
    "action": 1.0,
    "anchor": "brute_key",
    "card": "right",
    "composition": "split",
    "layout": {
      "cardWidth": 0.36,
      "fill": 0.5
    },
    "eyebrow": "Local-first \u00b7 Windows",
    "staging": "standard",
    "callout": {
      "title": "Start an authorized test",
      "fact": "Settings, records and history stay in local storage.",
      "value": "No cloud required \u2014 sign up and open the Dashboard."
    },
    "labels": [],
    "card_style": "glass",
    "side": -1
  }
];

export const MOTION = {"path": "spline", "ease": "back", "hold": 0.18, "inertia": 9, "roll": 3, "fov": 0, "swing": 0, "lift": 0, "steps": 0, "state": "spring", "feel": "bounce"};

export const LAYOUT = [
  {
    "name": "desktop",
    "minWidth": 1200,
    "cardWidth": "27.0vw",
    "inset": "4.0vw",
    "cardMaxHeight": "72vh",
    "band": "0px",
    "cardFraction": 0.27,
    "insetFraction": 0.04,
    "zone": 0.67,
    "shift": 0.165,
    "subjectFill": 0.62
  },
  {
    "name": "tablet",
    "minWidth": 768,
    "cardWidth": "36.0vw",
    "inset": "3.0vw",
    "cardMaxHeight": "72vh",
    "band": "0px",
    "cardFraction": 0.36,
    "insetFraction": 0.03,
    "zone": 0.59,
    "shift": 0.205,
    "subjectFill": 0.58
  },
  {
    "name": "mobile",
    "minWidth": 0,
    "cardWidth": "calc(100vw - 32px)",
    "inset": "16px",
    "cardMaxHeight": "none",
    "band": "44.0vh",
    "bandFraction": 0.44,
    "zone": 1,
    "shift": 0,
    "subjectFill": 0.7
  }
];

export const COMPOSITIONS = {"statement": {"centered": true, "fill": 0.42, "vshift": 0.12}, "split": {"card": 0.4, "fill": 0.62}, "numeral": {"card": 0.34, "fill": 0.6}, "annotate": {"card": null, "fill": null}, "fullbleed": {"centered": true, "fill": 0.85, "vshift": 0.0}, "pane": {"card": 0.46, "fill": 0.6}, "labels": {"centered": true, "fill": 0.72, "vshift": 0.0}};

/** The planned zones for a viewport width. */
export function layoutFor(width) {
  return LAYOUT.find((zone) => width >= zone.minWidth) || LAYOUT[LAYOUT.length - 1];
}

/** The zones for one shot at a viewport width: the page layout, the shot's composition and its own split. */
export function zoneFor(width, shot) {
  const base = layoutFor(width);
  const own = (shot && shot.layout) || {};
  const comp = COMPOSITIONS[(shot && shot.composition) || 'annotate'] || COMPOSITIONS.annotate;
  const fill = own.fill ?? comp.fill ?? base.subjectFill;
  if (base.name === 'mobile') return { ...base, subjectFill: own.fill ?? base.subjectFill, vshift: 0 };
  if (comp.centered) return { ...base, zone: 1, shift: 0, vshift: comp.vshift || 0, subjectFill: fill, centered: true };
  const raw = own.cardWidth ?? comp.card;
  const card = raw == null ? base.cardFraction : Math.min(0.48, raw + (base.name === 'tablet' ? 0.09 : 0));
  const used = card + base.insetFraction + 0.02;
  return {
    ...base, cardFraction: card, cardWidth: `${(card * 100).toFixed(1)}vw`,
    zone: 1 - used, shift: used / 2, vshift: 0, subjectFill: fill,
  };
}

/** Camera distance at which a subject of bounding radius `radius` fills `fill` of a view
 *  (vertical fov in degrees, `aspect` = the free zone's width / height). */
export function fitDistance(radius, fovDeg, fill, aspect) {
  const half = Math.min((fovDeg * Math.PI) / 360, Math.atan(Math.tan((fovDeg * Math.PI) / 360) * aspect));
  return radius / Math.sin(half) / Math.max(0.1, fill);
}
